import React from 'react';
import './ServiceIntro.css';

const ServiceIntro = ({
  title,
  subtitle,
  description,
  image,
  imageObjectFit = 'cover'
}) => {
  return (
    <section className="service-intro container">
      <div className="service-intro-header">
        <div className="service-intro-text">
          <h1 className="service-title">
            {title}
            <span className="title-underline"></span>
          </h1>
          {subtitle && <p>
            {subtitle}
          </p>}
          <div className="service-description">

            {Array.isArray(description) && (
              description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))
            )}


            {/* 主要描述部分 */}
            {description?.mainText && (
              <p>{description.mainText}</p>
            )}

            {/* 产品体系部分 */}
            {description?.systemTitle && (
              <div className="product-systems mb-4">
                <h3 className="system-title mb-2">{description.systemTitle}</h3>
                <ul className="system-list">
                  {description.systems?.map((system, index) => {
                    const [title, content] = system.split('：');
                    return (
                      <li key={index} className="system-item">
                        <strong>{title}</strong>：{content}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {/* 核心功能部分 */}
            {description?.features?.title && (
              <div className="core-features mb-4">
                <h3 className="features-title mb-2">{description.features.title}</h3>
                <div className="features-content">
                  {description.features.items?.map((feature, index) => {
                    const [title, content] = feature.split('：');
                    return (
                      <p key={index} className="feature-item mb-2">
                        <strong>{title}</strong>：{content}
                      </p>
                    );
                  })}
                </div>
              </div>
            )}

            {/* 应用场景部分 */}
            {description?.scenarios?.title && (
              <div className="scenarios mb-4">
                <h3 className="scenarios-title mb-2">{description.scenarios.title}</h3>
                <p className="scenarios-intro">{description.scenarios.intro}</p>
                <ul className="scenarios-list">
                  {description.scenarios.items?.map((scenario, index) => {
                    const [title, content] = scenario.split('：');
                    return (
                      <li key={index} className="scenario-item">
                        <strong>{title}</strong>：{content}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {/* 总结部分 */}
            {description?.summary && (
              <p className="summary mt-4">{description.summary}</p>
            )}
          </div>
        </div>
        <div className="service-intro-image">
          <img
            src={image}
            alt={title}
            style={{ objectFit: imageObjectFit }}
          />
        </div>
      </div>
    </section>
  );
};

export default ServiceIntro; 